interface ChatInputProps {
  input: string
  onInputChange: (value: string) => void
  onSend: () => void
  onGetSuggestions: () => void
  sending: boolean
  loadingSuggestions: boolean
  stageLocked: boolean
  stageLockedMessage: string
  onStartMinigame: () => void
  minigameActive: boolean
  onRevealQuestion: () => void
  availableQuestionsCount: number
  revealingQuestion: boolean
}

export default function ChatInput({
  input,
  onInputChange,
  onSend,
  onGetSuggestions,
  sending,
  loadingSuggestions,
  stageLocked,
  stageLockedMessage,
  onStartMinigame,
  minigameActive,
  onRevealQuestion,
  availableQuestionsCount,
  revealingQuestion,
}: ChatInputProps) {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      onSend()
    }
  }

  return (
    <div className="p-3 bg-base-100 border-t border-base-200"
      style={{ paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))' }}>
      {stageLocked ? (
        <div className="alert alert-warning shadow-lg mb-4">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
            <span>{stageLockedMessage}</span>
          </div>
        </div>
      ) : (
        <div className="flex gap-2 w-full">
          {/* 게임 버튼 */}
          {!minigameActive && (
            <button
              onClick={onStartMinigame}
              className="btn btn-circle btn-ghost flex-shrink-0"
              title="동시답변 게임 (무료)"
            >
              <span className="text-xl">🎮</span>
            </button>
          )}

          {/* 질문 공개 버튼 */}
          <button
            onClick={onRevealQuestion}
            className="btn btn-circle btn-ghost flex-shrink-0 relative"
            title="질문 공개하기"
            disabled={revealingQuestion}
          >
            {revealingQuestion ? (
              <span className="loading loading-spinner loading-sm"></span>
            ) : (
              <>
                <span className="text-xl">🎁</span>
                {availableQuestionsCount > 0 && (
                  <span className="badge badge-xs badge-primary absolute -top-1 -right-1">
                    {availableQuestionsCount}
                  </span>
                )}
              </>
            )}
          </button>

          {/* AI 연애 코치 버튼 (무료) */}
          <button
            onClick={onGetSuggestions}
            className="btn btn-circle btn-ghost text-primary flex-shrink-0"
            disabled={loadingSuggestions}
            title="연애 코치 (무료 5회/일)"
          >
            {loadingSuggestions ? (
              <span className="loading loading-spinner loading-sm"></span>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
              </svg>
            )}
          </button>

          <input
            type="text"
            value={input}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="메시지를 입력하세요..."
            className="input input-bordered flex-1 min-w-0"
            disabled={sending}
          />
          <button
            onClick={onSend}
            className="btn btn-primary btn-circle flex-shrink-0"
            disabled={!input.trim() || sending}
          >
            {sending ? (
              <span className="loading loading-spinner loading-sm"></span>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                />
              </svg>
            )}
          </button>
        </div>
      )}
    </div>
  )
}
